var systemMediaControls;
var castingPicker;
var self = this;

export default {
    init () {
        var audioElement = document.getElementById("radio_stream");
        if (!audioElement) {
            return;
        }

        // Add the event listener to handle Windows activated event
        if (typeof Windows !== "undefined") {
            self = this;
            systemMediaControls = Windows.Media.SystemMediaTransportControls.getForCurrentView();
            systemMediaControls.addEventListener("buttonpressed", this.systemMediaControlsButtonPressed, false);

            systemMediaControls.isPlayEnabled = true;
            systemMediaControls.isPauseEnabled = true;
            systemMediaControls.isStopEnabled = true;

            systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.closed;

            audioElement.addEventListener("pause", this.mediaPaused);
            audioElement.addEventListener("playing", this.mediaPlaying);
            audioElement.addEventListener("ended", this.mediaEnded);
            this.updateBadgeGlyph("playing");
        }

        // Setup mediasession for android/chrome
        if ('mediaSession' in navigator) {
            // Setup mediasession stuff for chrome/android
            navigator.mediaSession.setActionHandler('play', this.playMedia);
            navigator.mediaSession.setActionHandler('pause', this.pauseMedia);
    
        }
    },

    // Event handler for SystemMediaTransportControls' buttonpressed event
    systemMediaControlsButtonPressed(eventIn) {
        var mediaButton = Windows.Media.SystemMediaTransportControlsButton;

        switch (eventIn.button) {
            case mediaButton.play:
                self.playMedia();
                break;

            case mediaButton.pause:
                self.pauseMedia();
                break;

            case mediaButton.stop:
                self.stopMedia();
                break;

            // Insert additional case statements for other buttons you want to handle
        }
    },

    // Plays the media.
    playMedia() {
        var media = document.getElementById("radio_stream");
        media.play();
    },

    // Pauses the media.
    pauseMedia() {
        var media = document.getElementById("radio_stream");
        media.pause();
    },

    // Stops the media.
    stopMedia() {
        var media = document.getElementById("radio_stream");
        media.pause();
        media.currentTime = 0;
    },

    // The media Play event handler.
    mediaPlaying() {
        // Update the SystemMediaTransportControl state.
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.playing;
        self.updateBadgeGlyph("paused");
    },

    // The media Pause event handler.
    mediaPaused() {
        // Update the SystemMediaTransportControl state.
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.paused;
        self.updateBadgeGlyph("playing");
    },

    // The media Ended event handler.
    mediaEnded() {
        // Update the SystemMediaTransportControl state.
        systemMediaControls.playbackStatus = Windows.Media.MediaPlaybackStatus.stopped;
        self.updateBadgeGlyph("none");
    },

    updateMediaControls(artistName, trackName, trackArtwork) {
        if (typeof Windows !== 'undefined') {
            var displayUpdater = systemMediaControls.displayUpdater;

            displayUpdater.clearAll(); // Apparently needed to stop it crashing
            displayUpdater.type = Windows.Media.MediaPlaybackType.music;

            displayUpdater.musicProperties.artist = artistName;
            displayUpdater.musicProperties.title = trackName;

            try {
                var uri = new Windows.Foundation.Uri(trackArtwork);
                displayUpdater.thumbnail = Windows.Storage.Streams.RandomAccessStreamReference.createFromUri(uri);
            }
            catch ( err ) {
                console.log( "Error updating artwork" );
                console.log( err );
            }

            displayUpdater.update();

            try {
                this.updateLiveTile(artistName, trackName, trackArtwork);
            }
            catch ( err ) {
                console.log( err );
            }

            //makeShareButton();
        }
        else if ('mediaSession' in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: trackName,
                artist: artistName,
                artwork: [
                  { src: trackArtwork, sizes: '512x512', type: 'image/png' },
                ]
            })
        }
    },

    updateLiveTile(artistName, trackName, artwork) {
        if ( typeof Windows !== 'undefined' ) {
            var Notifications = Windows.UI.Notifications;

            var tileUpdater = Notifications.TileUpdateManager.createTileUpdaterForApplication();
            tileUpdater.enableNotificationQueue(false);
            tileUpdater.clear();

            var wideTileXml = Notifications.TileUpdateManager.getTemplateContent( Notifications.TileTemplateType.tileWide310x150PeekImage01 );

            var tileAttributes = wideTileXml.getElementsByTagName("text");
            tileAttributes[0].appendChild(wideTileXml.createTextNode(trackName));
            tileAttributes[1].appendChild(wideTileXml.createTextNode(artistName));
            wideTileXml.getElementsByTagName("image")[0].setAttribute( "src", artwork );

            var mediumTileXml = Notifications.TileUpdateManager.getTemplateContent( Notifications.TileTemplateType.tileSquarePeekImageAndText01 );

            var medTileAttributes = mediumTileXml.getElementsByTagName("text");
            medTileAttributes[0].appendChild(mediumTileXml.createTextNode(trackName));
                    medTileAttributes[1].appendChild(mediumTileXml.createTextNode(artistName));
            mediumTileXml.getElementsByTagName("image")[0].setAttribute( "src", artwork );

            var combined = wideTileXml.importNode( mediumTileXml.getElementsByTagName( "binding" ).item(0), true );
            wideTileXml.getElementsByTagName( "visual" ).item(0).appendChild( combined );

            var tileNotification = new Notifications.TileNotification(wideTileXml);

    /*		var currentTime = new Date();
            tileNotification.expirationTime = new Date(currentTime.getTime() + 600 * 1000);*/

            // Send the notification to the calling app's tile.
            Notifications.TileUpdateManager.createTileUpdaterForApplication().update(tileNotification);
        }
    },

    registerForShare() {
        try {
            var dataTransferManager = Windows.ApplicationModel.DataTransfer.DataTransferManager.getForCurrentView();
            dataTransferManager.addEventListener("datarequested", shareTextHandler);
        }
        catch ( err ) {
            console.log( err );
        }
    },

    shareTextHandler(e) {
        var request = e.request;

        var displayUpdater = systemMediaControls.displayUpdater;

        var artist = displayUpdater.musicProperties.artist;
        var title = displayUpdater.musicProperties.title;

        if (( artist.length > 0 ) && ( title.length > 0 ) ) {
            request.data.properties.title = "Madnight Radio";
            request.data.properties.description = "Share what you're currently listening to on Madnight Radio!";

            //request.data.setWebLink( "http://radio.madnight.co.uk" );
            request.data.setText( "I am currently listening to " + artist + " - " + title + " on Madnight Radio! (http://radio.madnight.co.uk)" );
        }
    },

    makeShareButton() {
        if ($('.radio-controls.container').find('.share-button').length > 0) {
            return;
        }
        
        var $shareButton = $('<div>', {
            id: 'showShareButton',
            class: 'share-button',
            html: '<span class="fa fa-comment-o"></span>',
            title: 'Click to share'
        });

        $shareButton.unbind('click').bind('click', function() {
            Windows.ApplicationModel.DataTransfer.DataTransferManager.showShareUI();
        });
    
        var thing = $('.radio-controls.container');
        thing.append($shareButton);
    },

    setupPlayTo() {
        /*var ptm = Windows.Media.PlayTo.PlayToManager.getForCurrentView();
        ptm.addEventListener("sourcerequested", sourceRequestHandler, false);*/

        castingPicker = new Windows.Media.Casting.CastingDevicePicker();
        castingPicker.addEventListener( "CastingDeviceSelected", castingDeviceSelectedHandler, false );
    },

    showPlayTo() {
        var rect = {
        height : 96,
        width : 64,
        x : 0,
        y : 0
        };

        castingPicker.show(rect);
    },

    sourceRequestHandler(e) {
        try {
            var sr = e.sourceRequest;
            var controller;

            try {
            var mediaElement = document.getElementById("radio_stream");
                controller = mediaElement.msPlayToSource;
            } catch (ex) {
            }

            sr.setSource(controller);
        } catch (ex) {
        }
    },

    castingDeviceSelectedHandler(e) {
        var connection = e.selectedCastingDevice.createCastingConnection();

        try {
                var mediaElement = document.getElementById("radio_stream");
                controller = mediaElement.msPlayToSource;
            connection.requestStartCastingAsync(controller);
        } catch (ex) {
        }

    },

    makePlayToButton() {
        var $playToButton = $('<div>', {
            id: 'showplayToButton',
            class: 'playto-button',
            html: '<span class="fa fa-external-link"></span>',
            title: 'Play to connected device'
        });

        $playToButton.unbind('click').bind('click', function() {
            //Windows.Media.PlayTo.PlayToManager.showPlayToUI(); 
            showPlayTo();
        });

        var thing = $('.radio-controls.container');
        thing.append($playToButton);
    },

    updateBadgeGlyph(glyphType) {
        console.log("setting glyp to", glyphType);
        var Notifications = Windows.UI.Notifications;

        var badgeXml = Notifications.BadgeUpdateManager.getTemplateContent(Notifications.BadgeTemplateType.badgeGlpyh);
        var badgeAttributes = badgeXml.getElementsByTagName("badge");
        badgeAttributes[0].setAttribute("value", glyphType);

        // Create a badge notification from XML
        var badgeNotification = new Notifications.BadgeNotification(badgeXml);

        Notifications.BadgeUpdateManager.createBadgeUpdaterForApplication().update(badgeNotification);
    }
}



// WEBPACK FOOTER //
// ./src/winapp.js